import { SORT_DIRECTION_ASC } from "constants/table";
import { numberIdentifier } from "./constants";

export const sortArray = (column, sortDirection, tableOption) => {
  const { identifier } = column;
  let newData = [];

  newData = tableOption.data.sort((a, b) => {
    const nameA = a[identifier].toUpperCase();
    const nameB = b[identifier].toUpperCase();

    if (nameA < nameB) {
      return sortDirection === SORT_DIRECTION_ASC ? -1 : 1;
    }

    if (nameA > nameB) {
      return sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
    }

    return 0;
  });

  return newData;
};

export const sortAtcs = (column, sortDirection, tableOption) => {
  const { identifier } = column;
  let newData = [];

  if (numberIdentifier.includes(identifier)) {
    if (sortDirection === SORT_DIRECTION_ASC) {
      newData = tableOption.data.sort((a, b) => a[identifier] - b[identifier]);
    } else {
      newData = tableOption.data.sort((a, b) => b[identifier] - a[identifier]);
    }
  }

  if (identifier === "scope") {
    newData = tableOption.data.sort((a, b) => {
      const municipalitiesA = a.user_account[0].scope_municipalities
        .map((m) => m.name)
        .join(",");

      const municipalitiesB = b.user_account[0].scope_municipalities
        .map((m) => m.name)
        .join(",");

      if (municipalitiesA < municipalitiesB) {
        return sortDirection === SORT_DIRECTION_ASC ? -1 : 1;
      }

      if (municipalitiesA > municipalitiesB) {
        return sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
      }

      return 0;
    });
  }

  if (identifier === "province") {
    newData = tableOption.data.sort((a, b) => {
      const provinceA = a.user_account[0].scope_province.name.toUpperCase();

      const provinceB = b.user_account[0].scope_province.name.toUpperCase();

      if (provinceA < provinceB) {
        return sortDirection === SORT_DIRECTION_ASC ? -1 : 1;
      }

      if (provinceA > provinceB) {
        return sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
      }

      return 0;
    });
  }

  if (identifier === "partner") {
    newData = tableOption.data.sort((a, b) => {
      const municipalityA = a.municipalities.map((m) => m.name).join(",");

      const municipalityB = b.municipalities.map((m) => m.name).join(",");

      if (municipalityA < municipalityB) {
        return sortDirection === SORT_DIRECTION_ASC ? -1 : 1;
      }

      if (municipalityA > municipalityB) {
        return sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
      }

      return 0;
    });
  }

  newData = tableOption.data.sort((a, b) => {
    const nameA = a[identifier]?.toUpperCase();
    const nameB = b[identifier]?.toUpperCase();

    if (nameA < nameB) {
      return sortDirection === SORT_DIRECTION_ASC ? -1 : 1;
    }

    if (nameA > nameB) {
      return sortDirection === SORT_DIRECTION_ASC ? 1 : -1;
    }

    return 0;
  });

  return newData;
};
